import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vtmn-absolute vtmn-z-50 vtmn-left-[50%] vtmn-top-[50%] -vtmn-translate-x-1/2 -vtmn-translate-y-1/2"
}
const _hoisted_2 = { class: "vtmn-sr-only" }
const _hoisted_3 = {
  key: 1,
  class: "vtmn-p-2 vtmn-bg-gray-50 vtmn-h-full"
}

import { onMounted, ref } from "vue";
import NavbarComp from "./components/molecules/NavbarComp.vue";
import BookingToastHost from "./modules/bookingsModule/components/shared/BookingToastHost.vue";
import fedidService from "./modules/oauth/services/FedidService";
import useAuth from "./modules/oauth/composables/useAuth";
import useHda from "./composables/useHda";
import { useI18n } from "vue-i18n";

import DecathlonLoader from "@/components/atoms/DecathlonLoader.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useI18n();

const authReady = ref(false);

onMounted(async () => {
  await fedidService.getTokenAndSaveData();
  const { loginState, accessToken } = useAuth();
  authReady.value = loginState.value && !!accessToken.value;
});

const { isSimpleLoading } = useHda();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(NavbarComp), null, {
    default: _withCtx(() => [
      _createVNode(BookingToastHost),
      (_unref(isSimpleLoading) || !authReady.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(DecathlonLoader, { size: "large" }),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("loading")), 1)
          ]))
        : _createCommentVNode("", true),
      (authReady.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_router_view)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})